var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 520.52 138.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#01126e;}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 55.15,
    y1: 137.53,
    x2: 74.05,
    y2: 105.13,
    gradientTransform: "translate(0 186) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ededed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 94.47,
    y1: 163,
    x2: 75.24,
    y2: 131.23,
    gradientTransform: "translate(0 186) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#003790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 135.93,
    y1: 90.83,
    x2: 98.23,
    y2: 90.83,
    gradientTransform: "translate(0 186) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#e74152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 59.13,
    y1: 90.96,
    x2: 97.64,
    y2: 90.8,
    gradientTransform: "translate(0 186) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 135.81,
    y1: 143.52,
    x2: 98.84,
    y2: 143.03,
    gradientTransform: "translate(0 186) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#cc267d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 138.59,
    y1: 95.89,
    x2: 120.92,
    y2: 128.93,
    gradientTransform: "translate(0 186) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fd5055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc267d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.86,96.47V41.17h10.59l23.54,39.03h-5.61l23.15-39.03h10.51l.16,55.3h-12.01l-.08-36.89h2.21l-18.49,31.05h-5.77l-18.88-31.05h2.69v36.89h-12.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.78,97.42c-4.27,0-8.24-.68-11.93-2.05-3.63-1.42-6.79-3.42-9.48-6-2.69-2.58-4.79-5.61-6.32-9.08-1.47-3.48-2.21-7.29-2.21-11.46s.74-7.98,2.21-11.45c1.53-3.48,3.63-6.5,6.32-9.09,2.74-2.58,5.93-4.56,9.56-5.93,3.63-1.42,7.61-2.13,11.93-2.13,4.79,0,9.11,.84,12.96,2.53,3.9,1.63,7.16,4.06,9.8,7.27l-8.22,7.58c-1.9-2.16-4-3.77-6.32-4.82-2.32-1.11-4.85-1.66-7.58-1.66-2.58,0-4.95,.42-7.11,1.26-2.16,.84-4.03,2.05-5.61,3.63-1.58,1.58-2.82,3.45-3.71,5.61-.84,2.16-1.26,4.56-1.26,7.19s.42,5.03,1.26,7.19c.9,2.16,2.13,4.03,3.71,5.61,1.58,1.58,3.45,2.79,5.61,3.63,2.16,.84,4.53,1.26,7.11,1.26,2.74,0,5.27-.53,7.58-1.58,2.32-1.11,4.42-2.76,6.32-4.98l8.22,7.58c-2.63,3.21-5.9,5.66-9.8,7.35-3.84,1.69-8.19,2.53-13.04,2.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320.95,97.42c-4.37,0-8.43-.71-12.17-2.13-3.69-1.42-6.9-3.42-9.64-6-2.69-2.58-4.79-5.61-6.32-9.08-1.47-3.48-2.21-7.27-2.21-11.38s.74-7.9,2.21-11.38c1.53-3.48,3.66-6.5,6.4-9.09,2.74-2.58,5.95-4.58,9.64-6,3.69-1.42,7.69-2.13,12.01-2.13s8.37,.71,12.01,2.13c3.69,1.42,6.87,3.42,9.56,6,2.74,2.58,4.87,5.61,6.4,9.09,1.53,3.42,2.29,7.22,2.29,11.38s-.76,7.93-2.29,11.46c-1.53,3.48-3.66,6.5-6.4,9.08-2.69,2.53-5.87,4.5-9.56,5.93-3.63,1.42-7.61,2.13-11.93,2.13Zm-.08-10.9c2.48,0,4.74-.42,6.79-1.26,2.11-.84,3.95-2.05,5.53-3.63,1.58-1.58,2.79-3.45,3.63-5.61,.9-2.16,1.34-4.56,1.34-7.19s-.45-5.03-1.34-7.19c-.84-2.16-2.05-4.03-3.63-5.61-1.53-1.58-3.34-2.79-5.45-3.63-2.11-.84-4.4-1.26-6.87-1.26s-4.77,.42-6.87,1.26c-2.05,.84-3.87,2.05-5.45,3.63-1.58,1.58-2.82,3.45-3.71,5.61-.84,2.16-1.26,4.56-1.26,7.19s.42,4.98,1.26,7.19c.9,2.16,2.11,4.03,3.63,5.61,1.58,1.58,3.42,2.79,5.53,3.63,2.11,.84,4.4,1.26,6.87,1.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M360.75,96.47V41.17h23.94c4.95,0,9.22,.82,12.8,2.45,3.58,1.58,6.35,3.87,8.3,6.87,1.95,3,2.92,6.58,2.92,10.74s-.98,7.66-2.92,10.67c-1.95,2.95-4.71,5.21-8.3,6.79-3.58,1.58-7.85,2.37-12.8,2.37h-16.83l5.69-5.61v21.01h-12.8Zm35.15,0l-13.83-20.07h13.67l13.98,20.07h-13.82Zm-22.36-19.59l-5.69-6h16.12c3.95,0,6.9-.84,8.85-2.53,1.95-1.74,2.92-4.11,2.92-7.11s-.97-5.42-2.92-7.11c-1.95-1.69-4.9-2.53-8.85-2.53h-16.12l5.69-6.08v31.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.61,63.45h26.62v9.95h-26.62v-9.95Zm.95,22.75h30.1v10.27h-42.82V41.17h41.79v10.27h-29.07v34.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.81,61.19v15.63l-24.95,14.46V46.69l24.95,14.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.81,61.19l-24.95-14.5,38.49-22.16v28.86l-13.54,7.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.35,113.53v-28.86l13.63-7.86,24.88,14.43v.03l-38.51,22.26Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.81,76.82l13.54,7.86v28.86l-38.49-22.26,24.95-14.46Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M97.35,53.47V24.63l38.51,22.06-24.88,14.5-13.63-7.72Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.98,61.19l24.88-14.5v44.56l-24.88-14.43v-15.63Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo-new.850ae4bb088dbf0ccf478ffbd1dfdc3f.svg";
export { ForwardRef as ReactComponent };